(function () {
  'use strict';

  const header = document.querySelector('.efx-header');
  const nav = document.querySelector('.efx-mm');
  if (!header || !nav) return;

  const items = nav.querySelectorAll('.efx-mm__item--has-mega');
  const hoverDelay = 150;
  const isSticky = header.getAttribute('data-sticky') === 'true';

  let closeTimer = null;
  let currentOpen = null;

  function openItem(item) {
    if (currentOpen && currentOpen !== item) {
      closeItem(currentOpen);
    }
    item.classList.add('efx-mm__item--open');
    const link = item.querySelector('.efx-mm__link');
    if (link) link.setAttribute('aria-expanded', 'true');
    currentOpen = item;
  }

  function closeItem(item) {
    item.classList.remove('efx-mm__item--open');
    const link = item.querySelector('.efx-mm__link');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (currentOpen === item) currentOpen = null;
  }

  function closeAll() {
    items.forEach(closeItem);
  }

  function scheduleClose(item) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => closeItem(item), hoverDelay);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  items.forEach((item) => {
    const link = item.querySelector('.efx-mm__link');
    const panel = item.querySelector('.efx-mm__panel');

    item.addEventListener('mouseenter', () => {
      cancelClose();
      openItem(item);
    });

    item.addEventListener('mouseleave', () => {
      scheduleClose(item);
    });

    if (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', () => scheduleClose(item));
    }

    if (link) {
      link.addEventListener('focus', () => openItem(item));
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          closeItem(item);
          link.blur();
        }
        if (e.key === 'ArrowDown' && panel) {
          e.preventDefault();
          openItem(item);
          const firstLeaf = panel.querySelector('.efx-mm__col-header, .efx-mm__leaf');
          if (firstLeaf) firstLeaf.focus();
        }
      });
    }
  });

  document.addEventListener('click', (e) => {
    if (!nav.contains(e.target)) {
      closeAll();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  if (isSticky) {
    const headerHeight = header.offsetHeight;
    let stickyActive = false;
    let ticking = false;

    function updateSticky() {
      const scrolled = window.scrollY > headerHeight;
      if (scrolled && !stickyActive) {
        header.classList.add('is-sticky');
        header.setAttribute('data-spacer', 'true');
        stickyActive = true;
      } else if (!scrolled && stickyActive) {
        header.classList.remove('is-sticky');
        header.removeAttribute('data-spacer');
        stickyActive = false;
      }
      ticking = false;
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateSticky);
        ticking = true;
      }
    }, { passive: true });
  }

  document.addEventListener('cart:updated', (e) => {
    const counters = document.querySelectorAll('[data-cart-count]');
    if (e.detail && typeof e.detail.item_count !== 'undefined') {
      const count = e.detail.item_count;
      counters.forEach((counter) => {
        counter.textContent = count;
        if (count === 0) {
          counter.classList.add('is-empty');
        } else {
          counter.classList.remove('is-empty');
        }
      });
    }
  });

  /* ============================================
     MOBILE PANEL TRANSITIONS
     ============================================ */

  const overlay = document.querySelector('[data-mm-overlay]');
  const backdrop = document.querySelector('[data-mm-backdrop]');
  const openBtn = document.querySelector('[data-mm-open]');
  const closeBtns = document.querySelectorAll('[data-mm-close]');
  const drillBtns = document.querySelectorAll('[data-mm-drill]');
  const backBtns = document.querySelectorAll('[data-mm-back]');
  const rootPanel = document.querySelector('.efx-mobile__panel--root');
  const subPanels = document.querySelectorAll('.efx-mobile__panel:not(.efx-mobile__panel--root)');

  if (!overlay) return;

  function openMenu() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (backdrop) {
      backdrop.classList.add('is-open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('efx-mobile-open');
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('efx-mobile-open');
    // Reset to root panel after transition completes
    setTimeout(() => {
      subPanels.forEach((p) => {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      });
      if (rootPanel) rootPanel.classList.remove('is-pushed');
    }, 280);
  }

  function drillTo(panelId) {
    const target = document.querySelector(`[data-mm-panel="${panelId}"]`);
    if (!target) return;
    // Hide any other open sub-panels
    subPanels.forEach((p) => {
      if (p !== target) {
        p.classList.remove('is-active');
        p.setAttribute('aria-hidden', 'true');
      }
    });
    target.classList.add('is-active');
    target.setAttribute('aria-hidden', 'false');
    target.scrollTop = 0;
    if (rootPanel) rootPanel.classList.add('is-pushed');
  }

  function drillBack() {
    subPanels.forEach((p) => {
      p.classList.remove('is-active');
      p.setAttribute('aria-hidden', 'true');
    });
    if (rootPanel) rootPanel.classList.remove('is-pushed');
  }

  if (openBtn) openBtn.addEventListener('click', openMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  closeBtns.forEach((btn) => btn.addEventListener('click', closeMenu));
  drillBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      const panelId = btn.getAttribute('data-mm-drill');
      drillTo(panelId);
    });
  });
  backBtns.forEach((btn) => btn.addEventListener('click', drillBack));

  // Close on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // ============================================
  // CART COUNT UPDATER
  // Listens for any /cart/add or /cart/change request, refreshes
  // the cart count badges, and animates them with a bounce.
  // ============================================

  function updateCartBadges(count) {
    const badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach((badge) => {
      badge.textContent = count;
      if (count > 0) {
        badge.classList.remove('is-empty');
      } else {
        badge.classList.add('is-empty');
      }
      // Restart the bounce animation
      badge.classList.remove('efx-cart-bounce');
      // Force reflow so the animation can re-trigger
      void badge.offsetWidth;
      badge.classList.add('efx-cart-bounce');
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((cart) => {
        updateCartBadges(cart.item_count);
      })
      .catch(() => {
        // Fail silently — Shopify will still process the add
      });
  }

  // Intercept fetch() calls (handles locked window.fetch)
try {
  const origFetch = window.fetch;

  const patchedFetch = function () {
    const fetchPromise = origFetch.apply(this, arguments);
    try {
      const url = arguments[0];
      const urlString = typeof url === 'string' ? url : (url && url.url) || '';
      if (
        urlString.includes('/cart/add') ||
        urlString.includes('/cart/change') ||
        urlString.includes('/cart/update')
      ) {
        fetchPromise.then(() => {
          setTimeout(refreshCartCount, 80);
        });
      }
    } catch (e) {
      // Ignore — just don't break the original fetch
    }
    return fetchPromise;
  };

  const desc = Object.getOwnPropertyDescriptor(window, 'fetch');
  if (!desc || desc.writable) {
    window.fetch = patchedFetch;
  } else if (desc.configurable) {
    Object.defineProperty(window, 'fetch', {
      value: patchedFetch,
      writable: false,       // preserve the lock so whoever set it doesn't break
      enumerable: desc.enumerable,
      configurable: true,
    });
  } else {
    console.warn('[EFX] window.fetch fully locked — relying on XHR + cart:updated');
  }
} catch (e) {
  console.warn('[EFX] fetch patch skipped:', e);
}

  // Intercept XMLHttpRequest (older add-to-cart forms / Turbo's AJAX)
  const origXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      const urlString = typeof url === 'string' ? url : '';
      if (
        urlString.includes('/cart/add') ||
        urlString.includes('/cart/change') ||
        urlString.includes('/cart/update')
      ) {
        setTimeout(refreshCartCount, 80);
      }
    });
    return origXhrOpen.apply(this, arguments);
  };
})();
